import * as Sentry from '@sentry/react';

export interface ReportErrorOptions {
  component?: string;
  tags?: Record<string, string>;
  extra?: Record<string, unknown>;
}

export function reportError(error: unknown, options: ReportErrorOptions = {}): void {
  const { component, tags, extra } = options;

  Sentry.captureException(error, {
    tags: { ...(component ? { component } : {}), ...(tags ?? {}) },
    extra,
  });
}
